if (!customElements.get('nc-quantity-breaks')) {
  customElements.define('nc-quantity-breaks', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.variantRequest = 0;
      this.variantPending = false;
      const {signal} = this.abort;
      this.details = this.closest('.product-details');
      this.section = this.closest('.shopify-section');
      this.addEventListener('click', event => {
        const option = event.target.closest('[data-quantity]');
        if (option && !option.disabled) this.select(option, true);
      }, {signal});
      this.section?.addEventListener('shopify:product:select', event => {
        if (!event.promise) return;
        const request = ++this.variantRequest;
        this.variantPending = true;
        this.setAttribute('aria-busy', 'true');
        this.querySelectorAll('[data-quantity]').forEach(option => option.disabled = true);
        event.promise.then(({detail}) => {
          if (!this.isConnected || request !== this.variantRequest) return;
          const next = detail?.html?.querySelector('nc-quantity-breaks');
          if (next) {
            this.dataset.stock = next.dataset.stock;
            this.dataset.available = next.dataset.available;
            this.dataset.currency = next.dataset.currency;
          } else this.dataset.available = String(detail?.resource?.available !== false);
          const price = Number(detail?.resource?.price);
          if (Number.isFinite(price)) this.updatePrices(price);
          this.variantPending = false;
          this.removeAttribute('aria-busy');
          requestAnimationFrame(() => { if (request === this.variantRequest) this.sync(); });
        }).catch(() => {
          if (!this.isConnected || request !== this.variantRequest) return;
          this.variantPending = false;
          this.removeAttribute('aria-busy');
          this.sync();
        });
      }, {signal});
      document.addEventListener('shopify:cart:lines-update', event => {
        Promise.resolve(event.promise).then(() => requestAnimationFrame(() => this.sync())).catch(() => {});
      }, {signal});
      document.addEventListener('nc:choose-pack', event => {
        const quantity = Number(event.detail?.quantity);
        const option = [...this.querySelectorAll('[data-quantity]')].find(item => Number(item.dataset.quantity) === quantity);
        if (option && !option.disabled) {
          this.select(option, true);
          this.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'center'});
          option.focus({preventScroll:true});
        }
      }, {signal});
      requestAnimationFrame(() => this.sync());
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.details?.classList.remove('has-nc-offers');
    }
    input() { return this.details?.querySelector('product-form-component input[name="quantity"]'); }
    sync() {
      if (this.variantPending) return;
      const input = this.input();
      if (!input) return;
      const min = Number(input.min || 1);
      const step = Number(input.step || 1);
      const cartQuantity = Number(input.dataset.cartQuantity || 0);
      let max = input.max ? Number(input.max) - cartQuantity : Infinity;
      if (this.dataset.stock !== '') max = Math.min(max, Number(this.dataset.stock) - cartQuantity);
      const available = this.dataset.available === 'true';
      const options = [...this.querySelectorAll('[data-quantity]')];
      for (const option of options) {
        const quantity = Number(option.dataset.quantity);
        option.disabled = !available || quantity < min || quantity > max || (quantity-min)%step !== 0;
        option.setAttribute('aria-disabled', String(option.disabled));
      }
      const selected = options.find(option => !option.disabled && Number(option.dataset.quantity) === Number(input.value));
      if (selected) this.mark(selected);
      else {
        const first = options.find(option => !option.disabled);
        if (first) this.select(first, false);
      }
      const hasOptions = options.some(option => !option.disabled);
      this.details.classList.toggle('has-nc-offers', hasOptions);
      this.classList.add('is-ready');
    }
    mark(option) {
      this.querySelectorAll('[data-quantity]').forEach(item => {
        const active = item === option;
        item.classList.toggle('is-active',active);
        item.setAttribute('aria-pressed',String(active));
      });
    }
    select(option,announce) {
      const input = this.input();
      if (!input || option.disabled) return;
      input.value = option.dataset.quantity;
      input.dispatchEvent(new Event('input',{bubbles:true}));
      input.dispatchEvent(new Event('change',{bubbles:true}));
      const selector = input.closest('quantity-selector-component');
      if (typeof selector?.onQuantityChange === 'function') selector.onQuantityChange();
      else input.dispatchEvent(new CustomEvent('quantity-selector:update',{bubbles:true,detail:{quantity:Number(input.value)}}));
      selector?.updateButtonStates?.();
      this.mark(option);
      if (announce) this.querySelector('[data-status]').textContent = option.querySelector('strong').textContent.trim()+' selected. '+option.querySelector('[data-total]').textContent+' total.';
    }
    updatePrices(price) {
      for (const option of this.querySelectorAll('[data-quantity]')) {
        const quantity=Number(option.dataset.quantity), discount=Number(option.dataset.discount || 0);
        const total=(price-Math.floor(price*discount/100))*quantity;
        option.querySelector('[data-total]').textContent=this.money(total);
        option.querySelector('[data-unit]').textContent=this.money(Math.round(total/quantity))+' each';
        const regular=option.querySelector('[data-regular]');
        if (regular) regular.textContent=this.money(price*quantity);
      }
    }
    money(value) { return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:this.dataset.currency||'USD'}).format(value/100); }
  });
}
document.addEventListener('click', event => {
  const trigger=event.target.closest('[data-nc-choose-pack]');
  if (!trigger) return;
  const selector=document.querySelector('nc-quantity-breaks.is-ready');
  if (!selector) return;
  const option = [...selector.querySelectorAll('[data-quantity]')].find(item => item.dataset.quantity === trigger.dataset.ncChoosePack);
  if (!option || option.disabled) return;
  event.preventDefault();
  document.dispatchEvent(new CustomEvent('nc:choose-pack',{detail:{quantity:Number(trigger.dataset.ncChoosePack)}}));
});

